import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const URL = `${process.env.REACT_APP_BACKEND_URL}/apInvoiceReturn`;
const initialState = { isLoading: false, error: null, returns: [], apInvoiceReturn: null, page: 1, limit: 10, totalPages: 0, totalResults: 0 };

const slice = createSlice({
  name: "accountsApInvoiceReturn",
  initialState,
  reducers: {
    startLoading(state) { state.isLoading = true; state.error = null; },
    hasError(state, action) { state.isLoading = false; state.error = action.payload; },
    getManySuccess(state, action) {
      const data = action.payload?.data || action.payload || {};
      state.isLoading = false;
      state.returns = data.results || data.apInvoiceReturns || (Array.isArray(data) ? data : []);
      state.page = data.page || 1;
      state.limit = data.limit || 10;
      state.totalPages = data.totalPages || 0;
      state.totalResults = data.totalResults ?? state.returns.length;
    },
    getOneSuccess(state, action) { state.isLoading = false; state.apInvoiceReturn = action.payload?.data || action.payload; },
    clearApInvoiceReturn(state) { state.apInvoiceReturn = null; state.error = null; },
  },
});

export default slice.reducer;
export const { clearApInvoiceReturn } = slice.actions;

export function getAccountsApInvoiceReturns({ franchiseId, warehouseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(URL, { params: { franchiseId, warehouseId, page, limit } });
      dispatch(slice.actions.getManySuccess(response.data));
      return response.data;
    } catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}
export function getAccountsApInvoiceReturn(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try { const response = await axios.get(`${URL}/${id}`); dispatch(slice.actions.getOneSuccess(response.data)); return response.data; }
    catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}
export function createAccountsApInvoiceReturn(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try { const response = await axios.post(URL, data); dispatch(slice.actions.getOneSuccess(response.data)); return response.data; }
    catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}
export function updateAccountsApInvoiceReturn(id, data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try { const response = await axios.patch(`${URL}/${id}`, data); dispatch(slice.actions.getOneSuccess(response.data)); return response.data; }
    catch (error) { dispatch(slice.actions.hasError(error)); throw error; }
  };
}
